import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MessageBox from "../../modules/shared/components/MessageBox";
import { actionToAddSkuItemInCart } from "../../actions/cartActions";
import LoadingBox from "../../modules/shared/components/LoadingBox";
import { actionToBringInCampaignedSku } from "../../actions/productActions";
import { PRODUCT_SKU_COMPAIGNED_RESET } from "../../constants/productConstants";
import SelectMultiVariant from "./SelectMultiVariant";
import useVariantSelection from "../../hooks/useVariantSelection";
import useVariantSelectedSku from "../../hooks/useVariantSelectedSku";

export default function FreeProductAddToCart(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  //PROPS COMING FROM ProductScreenNew
  const {
    loadingCampaign,
    errorCampaign,
    product,
    cartSkuItems,
    qty,
    index,
    setVariantAlert,
    setNoSkuAlert,
    isThereApendingOrder,
    skipCartScreen,
  } = props;

  // ARRAY THAT HOLDS CHOOSEN VARIANTS
  const [choosenVariants, setChoosenVariants] = useState("");

  // CREATE AN ARRAY WITH PRODUCT SKUS
  const variants = useVariantSelection(
    loadingCampaign,
    errorCampaign,
    product,
    choosenVariants
  );

  // SELECTED SKU
  const multiSku = useVariantSelectedSku(
    variants.fullVariantsArray,
    choosenVariants,
    product,
    actionToBringInCampaignedSku
  );

  //REDUX STATE THAT HOLDS PRODUCT SKU DETAILS
  const bringInCampaignedSku = useSelector(
    (state) => state.bringInCampaignedSku
  );
  const {
    loading: loadingSkuData,
    error: errorSkuData,
    skuData,
  } = bringInCampaignedSku;

  //REACT STATE TO MANAGE FREE VARIANT HAS NOT BEEN CHOOSEN ALERT
  const [choosen, setChoosen] = useState(true);

  function addToCartHandlerBuyOneGetOneFree() {
    let free = true;
    let discounted = false;

    if (
      choosenVariants.length !== variants.fullVariantsArray.length &&
      !variants.singleSku
    ) {
      return setChoosen(false);
    }

    if (
      cartSkuItems.length === 0 &&
      product._id &&
      (multiSku || variants.singleSku) &&
      qty
    ) {
      dispatch(
        actionToAddSkuItemInCart(
          isThereApendingOrder,
          product._id,
          multiSku || variants.singleSku,
          qty,
          "freeProductModal"
        )
      );

      if (skipCartScreen) {
        history.push("/siparis-bilgileri-adim-1/2");
      } else {
        history.push("/sepet");
      }
    } else if (
      cartSkuItems.length >= 1 &&
      cartSkuItems[0].sku === (multiSku || variants.singleSku) &&
      !product.buyOneGetOneFree &&
      product._id &&
      qty
    ) {
      dispatch(
        actionToAddSkuItemInCart(
          isThereApendingOrder,
          product._id,
          multiSku || variants.singleSku,
          qty,
          "freeProductModal"
        )
      );

      if (skipCartScreen) {
        history.push("/siparis-bilgileri-adim-1/2");
      } else {
        history.push("/sepet");
      }
    } else if (
      cartSkuItems.length >= 1 &&
      product._id &&
      (multiSku || variants.singleSku)
    ) {
      dispatch(
        actionToAddSkuItemInCart(
          isThereApendingOrder,
          product._id,
          multiSku || variants.singleSku,
          qty,
          "freeProductModal",
          discounted,
          free
        )
      );

      if (skipCartScreen) {
        history.push("/siparis-bilgileri-adim-1/2");
      } else {
        history.push("/sepet");
      }
    }
  }

  // RESET SKUDATA REDUX STATE
  useEffect(() => {
    return history.listen((location) => {
      if (location.pathname.match("/urun/")) {
        return null;
      } else {
        dispatch({ type: PRODUCT_SKU_COMPAIGNED_RESET });
      }
    });
  }, [history, dispatch, location]);

  return (
    <>
      {loadingCampaign ? (
        <LoadingBox></LoadingBox>
      ) : errorCampaign ? (
        <MessageBox></MessageBox>
      ) : (
        <div className="modal-content mar1 lightbck">
          <div className="w100p col-jus">
            {/* IF VARIANT IS NOT CHOOSEN ALERT MESSAGE DISPLAYED */}
            <div className="w100p marsideh">
              {cartSkuItems[cartSkuItems.length - 1].qty > 1 ? (
                <h3 className="fs15 txtcenter marb1">
                  {cartSkuItems[cartSkuItems.length - 1].qty} Adet Bedava Ürün
                  İçin Özellik Seçiniz
                </h3>
              ) : (
                <h3 className="fs15 txtcenter marb1">
                  {variants.singleSku
                    ? "Tebrikler! Bedava Ürün Kazandınız"
                    : "Bedava Ürün İçin Özellik Seçiniz"}
                </h3>
              )}
              {!choosen && (
                <MessageBox variant="danger">
                  <h2 className="h2cnp">
                    Lütfen bedava ürün için özellik seçiniz.
                  </h2>
                </MessageBox>
              )}
              <div className="row-left-align-center-nowrap">
                {loadingSkuData ? (
                  <img
                    className="small-image marh"
                    src={product.defaultImages[0]}
                    alt={product.name}
                  />
                ) : errorSkuData ? (
                  <img
                    className="small-image marh"
                    src={product.defaultImages[0]}
                    alt={product.name}
                  />
                ) : !skuData ? (
                  <img
                    className="small-image marh"
                    src={product.defaultImages[0]}
                    alt={product.name}
                  />
                ) : (
                  skuData && (
                    <img
                      className="small-image marh"
                      src={skuData.skus[0].skuImages[0]}
                      alt={product.name}
                    />
                  )
                )}

                <h2 className="fs125">{product.name}</h2>
              </div>
              <div className="w100p row-center-nowrap">
                <SelectMultiVariant
                  singleSku={variants.singleSku}
                  fullVariantsArray={variants.fullVariantsArray}
                  setChoosenVariants={setChoosenVariants}
                  index={index}
                  setVariantAlert={setVariantAlert}
                  setNoSkuAlert={setNoSkuAlert}
                  areVariantsInArow={true} // Variants can be in a column or in a row
                />
              </div>
            </div>
          </div>
          {cartSkuItems[cartSkuItems.length - 1].qty > 1 && (
            <h4 className="h4c green">
              <strong>İpucu:</strong> Her bir ürüne farklı özellik seçimi yapmak
              için ürün detayına dönün ve sepete tek tek ekleyin.
            </h4>
          )}
          {Array.from(product.skus.map((sku) => sku.countInStock)).reduce(
            (a, c) => a + c,
            0
          ) > 0 ? (
            <button
              className="primary w100p"
              type="button"
              disabled={
                Array.from(product.skus.map((sku) => sku.countInStock)).reduce(
                  (a, c) => a + c,
                  0
                ) === 0
              }
              onClick={() => addToCartHandlerBuyOneGetOneFree()}
            >
              {cartSkuItems[cartSkuItems.length - 1].qty > 1
                ? "Bedava Ürünleri Sepete Ekle"
                : "Bedava Ürünü Sepete Ekle"}
            </button>
          ) : (
            ""
          )}
        </div>
      )}
    </>
  );
}
